var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconComment = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.074 17.433a2.005 2.005 0 0 1 1.828-.257c1.087.385 2.305.606 3.6.606 5.114 0 8.53-3.233 8.53-6.427 0-3.193-3.416-6.427-8.53-6.427-5.113 0-8.528 3.234-8.528 6.427 0 1.286.508 2.523 1.463 3.583.353.39.525.904.484 1.426a6.993 6.993 0 0 1-.463 1.985c.697-.318 1.275-.671 1.616-.912v-.004zm-4.2 1.63c.074-.108.144-.216.21-.325.41-.666.8-1.542.877-2.526-1.23-1.37-1.956-3.045-1.956-4.857C3.005 6.74 7.705 3 13.503 3 19.3 3 24 6.74 24 11.355c0 4.616-4.7 8.356-10.497 8.356a12.79 12.79 0 0 1-4.269-.72c-.488.35-1.283.828-2.227 1.23-.619.265-1.324.506-2.054.646-.033.008-.066.012-.098.02-.18.033-.357.06-.542.077-.008 0-.02.004-.028.004-.21.02-.419.032-.628.032a.657.657 0 0 1-.607-.398.634.634 0 0 1 .14-.699c.168-.168.32-.35.463-.542.07-.092.136-.185.197-.277l.012-.02h.013z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconComment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-comment.b8796224.svg";
export { ForwardRef as ReactComponent };